import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Link from 'next/link';
import animateScrollTo from 'animated-scroll-to';
var logo = "/static/logos/qantas-logo-notxt.png";
import { Container } from "../_global";
import { NavWrapper, StyledFooter, AnchorTop, SubLinks, LogoWrapper, DownArrow } from "./style";
var SubFooter = /*#__PURE__*/function (_Component) {
  function SubFooter() {
    var _this;
    _classCallCheck(this, SubFooter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, SubFooter, [].concat(args)), _this.handleAnchorToTop = function () {
      animateScrollTo(0, {
        speed: 300
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(SubFooter, _Component);
  return _createClass(SubFooter, [{
    key: "render",
    value: function render() {
      return __jsx(NavWrapper, null, __jsx(StyledFooter, null, __jsx("div", {
        id: "page_footer",
        className: "sub-footer"
      }, __jsx(LogoWrapper, null, __jsx(Container, {
        veryWideView: true
      }, __jsx(Link, {
        href: "/"
      }, __jsx("a", null, __jsx("img", {
        src: logo,
        alt: "Qantas Shopping Logo"
      }))), __jsx(AnchorTop, {
        "aria-label": "Scroll to top",
        type: "button",
        onClick: this.handleAnchorToTop
      }, __jsx(DownArrow, {
        iconType: "chevronUp",
        size: "xs"
      }), __jsx("span", {
        className: "sr-only"
      }, "Back to top")))), __jsx(SubLinks, null, __jsx(Container, {
        veryWideView: true
      }, __jsx("ul", {
        className: "list-unstyled"
      }, __jsx("li", null, __jsx(Link, {
        href: "/contact-us"
      }, __jsx("a", null, "Contact Us"))), __jsx("li", null, __jsx(Link, {
        href: "/faqs"
      }, __jsx("a", null, "FAQs"))), __jsx("li", null, __jsx(Link, {
        href: "/how-it-works"
      }, __jsx("a", null, "How it works"))), __jsx("li", null, __jsx(Link, {
        href: "/terms-and-conditions"
      }, __jsx("a", null, "Terms and Conditions")))))))));
    }
  }]);
}(Component);
export default SubFooter;